import { Loader2 } from 'lucide-react';
import { cn } from '@/utils/cn';

/**
 * Loading indicator. Decorative on purpose: the words belong to the `role="status"` region around it,
 * so a screen reader announces the message once instead of announcing an icon as well.
 */
export function Spinner({ className }: { readonly className?: string }): React.JSX.Element {
  return (
    <Loader2 aria-hidden="true" className={cn('animate-spinner h-4 w-4 flex-none', className)} />
  );
}
